import type { ActionType } from "typesafe-actions";
import { createReducer } from "typesafe-actions";

import type { FetchError } from "app/pages/sales-intelligence/types";

import * as actionCreators from "./action-creators";
import type { ContactsStatus } from "./types";
import { ContactsAvailabilityStatus } from "./types";

export type ContactsState = {
    fetchContactsQuotaError: FetchError;
    fetchContactDetailsError: FetchError;
    contactsStatus: ContactsStatus;
    contactsAdmins: string[];
    loadingContactsStatus: boolean;
    isContactsStatusFetched: boolean;
    fetchContactsExportStatusError: FetchError;
};

const INITIAL_CONTACTS_STATE: ContactsState = {
    contactsStatus: {
        quota: {
            remaining: 0,
            total: 0,
            used: 0,
        },
        hasRevealedContacts: false,
        availability: ContactsAvailabilityStatus.DisabledByAccount,
    },
    contactsAdmins: [],
    loadingContactsStatus: false,
    isContactsStatusFetched: false,
    fetchContactsQuotaError: undefined,
    fetchContactDetailsError: undefined,
    fetchContactsExportStatusError: undefined,
};

const ContactsExportReducer = createReducer<ContactsState, ActionType<typeof actionCreators>>(INITIAL_CONTACTS_STATE)
    .handleAction(actionCreators.fetchContactsStatusAsync.request, (state) => ({
        ...state,
        loadingContactsStatus: true,
        fetchContactsExportStatusError: undefined,
    }))
    .handleAction(actionCreators.fetchContactsStatusAsync.failure, (state, { payload }) => ({
        ...state,
        loadingContactsStatus: false,
        fetchContactsExportStatusError: payload,
    }))
    .handleAction(actionCreators.fetchContactsStatusAsync.success, (state, { payload }) => {
        return {
            ...state,
            contactsStatus: payload,
            loadingContactsStatus: false,
            isContactsStatusFetched: true,
        };
    })
    .handleAction(actionCreators.approveContactsTermsAsync.request, (state) => ({
        ...state,
        loadingContactsStatus: true,
    }))
    .handleAction(actionCreators.approveContactsTermsAsync.failure, (state) => ({
        ...state,
        loadingContactsStatus: false,
    }))
    .handleAction(actionCreators.approveContactsTermsAsync.success, (state) => {
        return {
            ...state,
            contactsStatus: {
                ...state.contactsStatus,
                availability: ContactsAvailabilityStatus.Readonly,
            },
            loadingContactsStatus: false,
        };
    })
    .handleAction(actionCreators.fetchContactsAdmins.success, (state, { payload }) => ({
        ...state,
        contactsAdmins: payload,
    }));

export default ContactsExportReducer;
